import React from "react";

export default function IsgstToggle({
  checked = false,
  onChange = () => {},
  disabled = false,
}) {
  const handleClick = (e) => {
    if (disabled) return;
    // Prevent event bubbling to avoid duplicate calls
    e.stopPropagation();
    onChange(!checked);
  };

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`switch ${checked ? "is-on" : ""}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      title={checked ? "Available" : "Unavailable"}
      disabled={disabled}
    >
      <span className="switch-knob" />
    </button>
  );
}
